<plugin-outlet #widget [path]="widgetManifestPath" [childConfig]="widgetConfig"
(onInitialize)="onInitialize($event)" (onDeinitialize)="onDeinitialize($event)"
(onActivate)="onWidgetActivate($event)"></plugin-outlet>
